module.exports = __webpack_public_path__ + "img/success-svgrepo-com.d29f1779.svg";